import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { DEFAULT_ROWS_PER_PAGE } from '../../utils/paginationUtils';

export const fetchUsers = createAsyncThunk('clientUsers/list', (args = {}, { getState }) => {
  const state = getState();

  const { search, status, page, limit } = {
    search: args.search ?? state.clientUsers.options.search ?? 0,
    status: args.status ?? state.clientUsers.options.status ?? 'ALL',
    page: args.page ?? state.clientUsers.options.page ?? 1,
    limit: args.limit ?? state.clientUsers.options.limit ?? 10,
  };
  return api
    .get(
      `/clientUsers?search=${search ? encodeURIComponent(search) : ''}
     &page=${encodeURIComponent(page)}&limit=${encodeURIComponent(limit)}&status=${encodeURIComponent(status)}`
    )
    .then((response) => response.data);
});

export const createUser = createAsyncThunk('clientUsers/create', (args, { dispatch }) => {
  const { email, phone, first_name, last_name, role, status, password, verify_password } = args;
  return api
    .post('/clientUsers', { email, phone, first_name, last_name, role, status, password, verify_password })
    .then(() => dispatch(fetchUsers()));
});

export const updateUser = createAsyncThunk('clientUsers/update', (args, { dispatch }) => {
  const { user_id, email, phone, first_name, last_name, role, status, password, verify_password } = args;
  return api
    .put(`/clientUsers/${user_id}`, { email, phone, first_name, last_name, role, status, password, verify_password })
    .then(() => dispatch(fetchUsers()));
});

const initialState = {
  data: [],
  totalItems: 0,
  error: null,
  isLoading: false,
  options: {
    search: '',
    status: 'ALL',
    page: 1,
    limit: DEFAULT_ROWS_PER_PAGE,
  },
};

const clientUsersSlice = createSlice({
  name: 'clientUsers',
  initialState: initialState,
  reducers: {
    setFilters: (state, action) => {
      const { search, page, limit, status } = action.payload;
      if (search !== undefined) state.options.search = search;
      if (status !== undefined) state.options.status = status;
      if (page !== undefined) state.options.page = page;
      if (limit !== undefined) state.options.limit = limit;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.data = [];
    });

    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
      state.totalItems = action.payload.totalItems;
      state.options.page = action.payload.currentPage;
    });

    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(createUser.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(createUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(createUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(updateUser.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { setFilters } = clientUsersSlice.actions;
export default clientUsersSlice.reducer;
